export default __webpack_public_path__ + "static/media/heart-medical.538bfafd.svg";